import React from 'react';
import {
  Droplet, Camera, Activity, Zap, Home, Building, Warehouse,
  Droplets, Waves, CloudRain, FlaskConical, Thermometer, Wind,
  Sun, Wifi, RadioTower, Flame, AlertTriangle, Wrench, Gauge, Info,
} from 'lucide-react';
import { ActionButton } from '../ActionButton';
import { FOREST_GREEN, MID_GRAY, WHITE } from '@/styles/tokens';

const ICONS = [
  { name: 'pin', Icon: Droplet, label: 'Drop' },
  { name: 'camera', Icon: Camera, label: 'Camera' },
  { name: 'sensor', Icon: Activity, label: 'Sensor' },
  { name: 'power', Icon: Zap, label: 'Power' },
  { name: 'home', Icon: Home, label: 'Home' },
  { name: 'building', Icon: Building, label: 'Building' },
  { name: 'warehouse', Icon: Warehouse, label: 'Warehouse' },
  { name: 'water', Icon: Droplets, label: 'Water' },
  { name: 'waves', Icon: Waves, label: 'Waves' },
  { name: 'rain', Icon: CloudRain, label: 'Rain' },
  { name: 'flask', Icon: FlaskConical, label: 'Flask' },
  { name: 'temperature', Icon: Thermometer, label: 'Temp' },
  { name: 'wind', Icon: Wind, label: 'Wind' },
  { name: 'sun', Icon: Sun, label: 'Sun' },
  { name: 'wifi', Icon: Wifi, label: 'Wifi' },
  { name: 'radio', Icon: RadioTower, label: 'Radio' },
  { name: 'flame', Icon: Flame, label: 'Flame' },
  { name: 'warning', Icon: AlertTriangle, label: 'Alert' },
  { name: 'maintenance', Icon: Wrench, label: 'Maint.' },
  { name: 'gauge', Icon: Gauge, label: 'Gauge' },
  { name: 'info', Icon: Info, label: 'Info' },
] as const;

interface PinIconDrilldownProps {
  currentIcon?: string;
  onAutoSend: (command: string) => void;
  onDone: () => void;
}

export const PinIconDrilldown: React.FC<PinIconDrilldownProps> = ({
  currentIcon,
  onAutoSend,
  onDone,
}) => (
  <>
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: '8px 0' }}>
      <ActionButton variant="back" onClick={onDone}>
        ← Back
      </ActionButton>
      <span style={{ fontSize: '13px', color: MID_GRAY.DEFAULT }}>Choose an icon:</span>
    </div>
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
      {ICONS.map(({ name: iconName, Icon, label }) => {
        const isSelected = currentIcon === iconName;
        return (
          <button
            key={iconName}
            onClick={() => {
              onAutoSend(`use ${iconName} icon`);
              onDone();
            }}
            title={label}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '28px',
              height: '28px',
              borderRadius: '6px',
              border: `1.5px solid ${isSelected ? FOREST_GREEN.DEFAULT : 'rgba(47, 133, 90, 0.25)'}`,
              backgroundColor: isSelected ? FOREST_GREEN.DEFAULT : 'rgba(47, 133, 90, 0.06)',
              color: isSelected ? WHITE : FOREST_GREEN.DEFAULT,
              cursor: 'pointer',
              transition: 'all 150ms ease',
              flexShrink: 0,
            }}
            onMouseEnter={(e) => {
              if (!isSelected) {
                e.currentTarget.style.backgroundColor = 'rgba(47, 133, 90, 0.15)';
                e.currentTarget.style.borderColor = FOREST_GREEN.DEFAULT;
              }
            }}
            onMouseLeave={(e) => {
              if (!isSelected) {
                e.currentTarget.style.backgroundColor = 'rgba(47, 133, 90, 0.06)';
                e.currentTarget.style.borderColor = 'rgba(47, 133, 90, 0.25)';
              }
            }}
          >
            <Icon size={14} />
          </button>
        );
      })}
    </div>
  </>
);
